<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qm08f4/image/Front.jpg?1726850954207" alt="This image is the cover for the book Billy's New Bike"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Billy's New Bike
      </h1>
      <p class="bookDescription body article font2">
        <p>Billy is a wombat. Billy loves riding his bike, but he doesn’t like change. When faced with a choice between his old bike and a new shiny bike he receives for Christmas, he has to choose which one he will ride. Billy loves his old bike so much he can’t part with it! However, Billy soon realises that his new bike might actually get him where he wants to go much faster.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelly Hayduk
      </h2>
      
      <p class="authorDescription body article">Kelly enjoys writing children’s stories, each one coming from a curious quirk of one of her four children. Her house has always been filled with her children, their friends and children in foster care, which has taught her how to get into a child’s world and write stories they can identify with. Her love of children and writing has become a source of much joy for her and hopefully for her readers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5bdebea4